import styled from 'styled-components';

export const InputWrapper = styled.div`
  padding: 20px 0 0;
`;
